import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import { useDroits } from '../auth';
import { useAction, useApi } from '../hooks';
import { Chargement, MessageErreur, Pagination, Statut, formatDate } from '../components/ui';

const STATUTS = [
  ['', 'Tous les statuts'],
  ['PENDING', 'En attente'],
  ['SUCCESS', 'Réussies'],
];

export default function MisesAJour() {
  const { support } = useDroits();
  const [params] = useSearchParams();
  const workstationId = params.get('workstationId') || '';
  const [status, setStatus] = useState('');
  const [softwareId, setSoftwareId] = useState('');
  const [clientId, setClientId] = useState('');
  const [page, setPage] = useState(1);
  const { donnees: logiciels } = useApi('/logiciels');
  const { donnees: clients } = useApi('/clients/noms');
  const liste = useApi('/mises-a-jour', { status, softwareId, clientId, workstationId, page });
  const action = useAction();

  const annuler = (id) =>
    action.executer(async () => {
      await api(`/mises-a-jour/${id}`, { methode: 'DELETE' });
      liste.recharger();
    });

  return (
    <>
      <h1>Mises à jour</h1>
      {workstationId && (
        <p>
          Filtré sur un poste · <Link to="/mises-a-jour">voir toutes les mises à jour</Link>
        </p>
      )}
      <div className="barre-filtres">
        <select
          value={status}
          onChange={(e) => {
            setStatus(e.target.value);
            setPage(1);
          }}
        >
          {STATUTS.map(([valeur, libelle]) => (
            <option key={valeur} value={valeur}>
              {libelle}
            </option>
          ))}
        </select>
        <select
          value={softwareId}
          onChange={(e) => {
            setSoftwareId(e.target.value);
            setPage(1);
          }}
        >
          <option value="">Tous les logiciels</option>
          {logiciels?.map((l) => (
            <option key={l.id} value={l.id}>
              {l.name}
            </option>
          ))}
        </select>
        <select
          value={clientId}
          onChange={(e) => {
            setClientId(e.target.value);
            setPage(1);
          }}
        >
          <option value="">Tous les clients</option>
          {clients?.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
      </div>

      <MessageErreur erreur={action.erreur || liste.erreur} />
      {liste.chargement && !liste.donnees ? (
        <Chargement />
      ) : (
        liste.donnees && (
          <div className="carte">
            <table>
              <thead>
                <tr>
                  <th>Créée le</th>
                  <th>Client · poste</th>
                  <th>Logiciel</th>
                  <th>Version</th>
                  <th>Statut</th>
                  <th>Terminée le</th>
                  {support && <th />}
                </tr>
              </thead>
              <tbody>
                {liste.donnees.donnees.map((m) => (
                  <tr key={m.id}>
                    <td>{formatDate(m.createdAt, true)}</td>
                    <td>
                      {m.workstation.client.name} · <Link to={`/postes/${m.workstation.id}`}>{m.workstation.name}</Link>
                    </td>
                    <td>{m.software.name}</td>
                    <td>
                      {m.fromVersion?.version || '?'} → {m.toVersion.version}
                    </td>
                    <td>
                      <Statut valeur={m.status} />
                    </td>
                    <td>{formatDate(m.completedAt, true)}</td>
                    {support && (
                      <td>
                        {m.status === 'PENDING' && (
                          <button className="btn btn-lien btn-danger" disabled={action.enCours} onClick={() => annuler(m.id)}>
                            Annuler
                          </button>
                        )}
                      </td>
                    )}
                  </tr>
                ))}
                {liste.donnees.donnees.length === 0 && (
                  <tr>
                    <td colSpan={7} className="muted">
                      Aucune mise à jour.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination pagination={liste.donnees.pagination} onPage={setPage} />
          </div>
        )
      )}
    </>
  );
}
